import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import NewLayer from '../../pages/NewLayer';
import NewLayerFromServer from '../../pages/NewLayerFromServer';
import Layers from '../../../api/Layers/Layers';
import { GridContainer, Grid, GridMiddleChild } from './styles';
import MapContainerViewLayer from '../../containers/MapContainerViewLayer';
import ViewThematicLayerTable from '../../pages/ViewThematicLayerTable';
import { isThematic } from '../../../api/Layers/layer-operations';

const LayerMap = ({ layer, ...rest }) => (
  <Row noGutters>
    <Col xs={12}>
      {!isThematic(layer) && <MapContainerViewLayer height="90vh" layer={layer} {...rest} />}
      {isThematic(layer) && <ViewThematicLayerTable layer={layer} />}
    </Col>
  </Row>
);
LayerMap.propTypes = {
  layer: PropTypes.object.isRequired
};
const ModalElement = props => {
  const { modalShow, onHide, Componet, userControlSetting } = props;
  const [ipLayer, setIpLayer] = React.useState('');
  const [Layer, setLayer] = React.useState({});
  const [defaultBaseMap, setDefaultBaseMap] = React.useState({});

  React.useEffect(() => {
    setLayer(Layers.findOne(ipLayer));
    setDefaultBaseMap(Layers.findOne(userControlSetting.defaultBaseMap));
  }, [ipLayer]);
  return (
    <Modal
      show={modalShow}
      size="lg"
      dialogClassName="w-75 mw-100 mh-100"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => {
        onHide();
        setIpLayer('');
      }}
      centered
    >
      <Modal.Header closeButton />

      <Modal.Body className="p-0" style={{ height: '85vh', width: '100%' }}>
        <GridContainer heightToRemove="5%">
          <Grid>
            <GridMiddleChild height="100%" xs={12} horizontal>
              {!isEmpty(Layer) ? (
                <LayerMap layer={Layer} defaultBaseMap={defaultBaseMap} {...props} />
              ) : (
                <>
                  {Componet === 'New Layer' && <NewLayer setIpLayer={setIpLayer} {...props} />}
                  {Componet === 'Layer Load' && (
                    <NewLayerFromServer setIpLayer={setIpLayer} {...props} />
                  )}
                </>
              )}
            </GridMiddleChild>
          </Grid>
        </GridContainer>
      </Modal.Body>
    </Modal>
  );
};
ModalElement.defaultProps = {
  Componet: '',
  modalShow: false,
  onHide: () => {}
};
ModalElement.propTypes = {
  Componet: PropTypes.string,
  modalShow: PropTypes.bool,
  onHide: PropTypes.func,
  userControlSetting: PropTypes.object.isRequired
};
export default ModalElement;
